var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('button',{staticClass:"log-btn",on:{"click":_vm.log}},[_vm._v("btn")])])}
var staticRenderFns = []

export { render, staticRenderFns }